import Swiper, { Autoplay, Navigation, Pagination } from 'swiper';
import { swiperObserver } from '../../utils/swiper.utils.js';
import { swiperOnResize } from '../../utils/swiperOnResize.utils.js';

let leadersSwiperWr = document.querySelectorAll('.leaders-swiper-wr');
leadersSwiperWr.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    if (!swiperEl) {
      return;
    }

    let nextEl = el.querySelector('.swiper-button-next');
    let prevEl = el.querySelector('.swiper-button-prev');
    let paginationEl = el.querySelector('.swiper-pagination');
    let slidesCount = el.querySelectorAll('.swiper-slide').length;
    if (!slidesCount) {
      return;
    }

    let wrapper = swiperEl.querySelector('.swiper-wrapper');

    swiperOnResize('(max-width: 851px)', swiperEl,
        {
          modules: [Autoplay, Navigation, Pagination],
          slidesPerView: 1,
          spaceBetween: 20,
          autoplay: {
            delay: 4000,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
          },
          breakpoints: {
            641: {
              slidesPerView: 2,
            }
          },
          navigation: {
            prevEl: prevEl,
            nextEl: nextEl,
          },
          pagination: paginationEl ? {
            el: paginationEl,
            clickable: true,
          } : undefined,
        },
    );
  }
});
